<template>
  <!-- 업체물품 반입 신청 -->
  <div>
    <v-overlay :z-index="5000" :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card class="ma-4">
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="font-weight-bold" style="min-width:140px;">
          <v-icon class="mr-2">mdi-square-edit-outline</v-icon>업체물품 반입 신청
        </v-toolbar-title>
      </v-toolbar>
      <v-divider class="ml-4 mr-4"></v-divider>
      <v-toolbar dense flat color="white">
        <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
          SK 스페셜티 담당자
        </v-card-subtitle>
      </v-toolbar>
      <v-card outlined tile class="ma-4 essetial_card">
        <v-card-text class="pt-6 pb-0">
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <div class="d-flex">
                <v-text-field v-model="zChargeInfo.cEmailAddr1" @keyup="ResetEmailInfo()" @keyup.enter="GetChargeInfo()" class="mr-2" dense persistent-placeholder>
                  <template v-slot:label>
                    담당자 이메일<strong class="red--text">*</strong>
                  </template>
                </v-text-field>
                <v-select v-model="zChargeInfo.cEmailAddr2" :items="zEmaillAddr" @click:append-outer="GetChargeInfo()" append-outer-icon="search" auto-select-first dense style="width:160px;">
                  <template v-slot:prepend>
                    <div>@</div>
                  </template>
                </v-select>
              </div>
            </v-col>
            <v-col cols="6" sm="3" md="3">
              <v-text-field v-model="zChargeInfo.cUserNm" readonly label="담당자 이름" dense persistent-placeholder></v-text-field>
            </v-col>
            <!-- <v-col cols="6" sm="3" md="3">
              <v-text-field v-model="zChargeInfo.cPartNm" readonly label="담당자 부서" dense persistent-placeholder></v-text-field>
            </v-col> -->
          </v-row>
        </v-card-text>
      </v-card>

      <v-divider class="ml-4 mr-4"></v-divider>
      <v-toolbar dense flat color="white">
        <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
          기본정보
        </v-card-subtitle>
      </v-toolbar>
      <v-card outlined tile class="ma-4">
        <v-card-text class="pt-6 pb-0">
          <v-row class="pb-0">
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.cBizCode" label="사업자등록번호" dense disabled persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-if="editedItem.cLocal == 'Y'" v-model="editedItem.cCorpNmKor" label="협력사명" dense disabled persistent-placeholder></v-text-field>
              <v-text-field v-else v-model="editedItem.cCorpNmEng" label="협력사명" dense disabled persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="CustomInfo.CustomNm" label="반입자명" dense disabled persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="CustomInfo.Tel" label="휴대전화번호" dense disabled persistent-placeholder></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- <v-card outlined tile class="ma-4 essetial_card"> -->
      <v-card outlined tile class="ma-4 essetial_card">
        <v-card-text class="pt-6 pb-0">
          <v-row class="pb-0">
            <v-col cols="12" sm="6" md="3">
              <v-select
                :items="zCarryItem"
                v-model="editedItem.cLabel"
                @change="zCorCarryItem = [];AddRow(editedItem.cLabel);bPolicyCheck1 = false; bPolicyCheck2 = false;bPolicyCheck3 = false; bPolicyCheck4 = false;"
                dense
                persistent-placeholder
              >
                <template v-slot:label>
                  반입물품 분류<strong class="red--text">*</strong>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.cZone" @click:append-outer="ShowMapDialog()" append-outer-icon="map" dense readonly persistent-placeholder>
                <template v-slot:label>
                  반입건물<strong class="red--text">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.cReason" dense persistent-placeholder>
                <template v-slot:label>
                  반입사유<strong class="red--text">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="3">
              <v-radio-group v-model="editedItem.cSort" @change="DisableSelect()" mandatory row class="ma-0 ml-n1" style="min-width:250px;" dense>
                <v-radio value="1" label="반입/반출" color="primary"></v-radio>
                <v-radio value="2" label="반입/미반출" color="primary"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <IronDate ref="IronDateRef" v-model="editedItem.sNowSelectDate" @update="onDateRangeChange" @overmaxperiod="overmaxperiod" :bSelect="editedItem.cSort == '2'?true:false" :sMinDate="new Date()" cLabelEs="반입/반출 예정일" style="width:100%"/>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="editedItem.cLongReason" dense auto-grow rows="1" persistent-placeholder>
                <template v-slot:label>
                  반입사유 상세설명<strong class="red--text">*</strong>
                </template>
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>


      <!-- 반입물품 분류 전산기기 선택 시 -->
      <v-card flat tile v-if="editedItem.cLabel == '1'">
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-toolbar dense flat color="white">
          <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
            최신 OS 및 백신 설치의무 안내 및 동의
          </v-card-subtitle>
        </v-toolbar>
        <v-card-text>
          <div>전산기기 반입신청 품목에 대해서는 SK 스페셜티가 정한 표준OS로 설치 된 기기이며, 최신 Windows 보안 업데이트가 실행되어야 합니다.</div>
          <div>또한, 아래의 Anti Virus 프로그램 중 하나의 백신 프로그램이 설치되어야만 SK 스페셜티 내부로 반입이 가능합니다. (평가판 설치 가능)</div>
          <div>License를 보유하지 않은 상용 S/W의 사용은 엄격히 제한되며, 불법 S/W를 사용하여 발행하는 민/형사상의 책임은 사용자 개인에게 귀속됩니다.</div>
          <div>해당 절차를 통해 반입 된 전산기기는 최종 반출 시 반드시 포맷 후 반출 가능합니다.</div>
          <div class="mt-2">- 표준 OS : Windows 10Enterprise 1809 (Edu, home 버전은 Setup 불가로 사용 불가)</div>
          <div>- (※ 단, 업무상 Linux/Unix, MacOS 사용 필요시 반드시 사전 협의 후 승인된 기기만 반입 가능하며, 네트워크 사용이 차단됩니다.)</div>
          <div>- 허용 백신(안랩 V3, 하우리 바이로봇, Kaspersky, McAfee, Notion, Trend Micro,360 Security)</div>
          <v-checkbox v-model="bPolicyCheck1" dense class="mt-2" color="black">
            <template v-slot:label>
              <div class="black--text">동의합니다.</div>
            </template>
          </v-checkbox>
        </v-card-text>
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-toolbar dense flat color="white">
          <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
            추가 보안 서약
          </v-card-subtitle>
        </v-toolbar>
        <v-card-text>
          <div>
            상기 본인은 SK 스페셜티(이하 회사라 한다)를 출입하는 데 허가된 목적 외 산업 보안에 위배되는 행위를 하지 않을 것이며, 출입 회사의 허가없이 자료를 저장하지 않겠습니다.
            회사 영업비밀 등 자료의 반출이 필요한 경우 사전 예약부서팀장 승인을 득하여 저장 할 것이며, 
            반출 시 사전 승인된 자료라 할지라도 보안목적상 삭제 시에도 이의를 제기하지 않겠습니다. 또한 회사 영업비밀 등 업무자료를 불법 저장하거나 
            반출 시도 時 어떠한 법적조치도 감수하겠습니다.
          </div>
          <v-checkbox v-model="bPolicyCheck2" dense class="mt-2" color="black">
            <template v-slot:label>
              <div class="black--text">동의합니다.</div>
            </template>
          </v-checkbox>
        </v-card-text>
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-toolbar dense flat color="white">
          <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
            물품정보
          </v-card-subtitle>
          <v-spacer></v-spacer>
          <!-- <v-btn @click="AddRow(editedItem.cLabel)" dark width="120" class="text--white"> -->
          <v-btn @click="AddRow(editedItem.cLabel)" class="font-weight-bold" small dark width="70px"><v-icon small class="mr-1">mdi-plus</v-icon><div class="text-caption">추가</div></v-btn>
        </v-toolbar>
        <v-card-text>
          <div>※ SK 스페셜티 표준OS가 아닌 경우 EP센터 점검 후 사용이 가능하며, 허위로 OS를 선택하여 신청한 경우 허위 정보 제출로 산업 보안 규정에 의거하여 위규 처리 될 수 있습니다. </div>
        </v-card-text>
        <v-card-text class="pt-0 pb-0">
          <v-data-table
            :items="zCorCarryItem"
            :headers="headers1"
            :hide-default-footer="true">
            <template v-slot:header.cComEquipNm="{ }">
              <div>제조사/모델<strong class="ml-1 red--text">*</strong></div>
            </template>
            <template v-slot:header.cOsNm="{ }">
              <div>OS<strong class="ml-1 red--text">*</strong></div>
            </template>
            <template v-slot:header.cSerialNum="{ }">
              <div>Serial No.<strong class="ml-1 red--text">*</strong></div>
            </template>
            <template v-slot:header.cMaxAddr="{ }">
              <div>Mac Address</div>
            </template>
            <template v-slot:item.cComEquipNm="{ item }">
              <v-text-field v-model="item.cComEquipNm" persistent-placeholder></v-text-field>
            </template>
            <template v-slot:item.cOsNm="{ item }">
              <v-text-field v-model="item.cOsNm" persistent-placeholder></v-text-field>
            </template>
            <template v-slot:item.cSerialNum="{ item }">
              <v-text-field v-model="item.cSerialNum" persistent-placeholder></v-text-field>
            </template>
            <template v-slot:item.cMaxAddr="{ item }">
              <v-text-field v-model="item.cMaxAddr" persistent-placeholder></v-text-field>
            </template>
            <template v-slot:item.cDel="{ item }">
              <v-icon @click="DelRow(item)" color="black">mdi-close</v-icon>
            </template>
            <template v-slot:no-data>
              <div class="black--text">물품정보를 입력하여 주세요.</div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>


      <!-- 반입물품 분류 디지털 카메라 선택 시 -->
      <v-card flat tile v-if="editedItem.cLabel == '2'">
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-toolbar dense flat color="white">
          <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
            추가 보안 서약
          </v-card-subtitle>
        </v-toolbar>
        <v-card-text>
          <div>
            상기 본인은 SK 스페셜티(이하 회사라 한다)를 출입하는 데 허가된 목적 외 산업 보안에 위배되는 행위를 하지 않을 것이며, 
            출입 회사의 허가없이 자료를 저장하지 않겠습니다. 회사 영업비밀 등 자료의 반출이 필요한 경우 사전 예약부서팀장 승인을 득하여 저장 할 것이며, 
            반출 시 사전 승인된 자료라 할지라도 보안목적상 삭제 시에도 이의를 제기하지 않겠습니다. 또한 회사 영업비밀 등 업무자료를 불법 저장하거나 
            반출 시도 時 어떠한 법적조치도 감수하겠습니다.
          </div>
          <v-checkbox v-model="bPolicyCheck3" dense class="mt-2" color="black">
            <template v-slot:label>
              <div class="black--text">동의합니다.</div>
            </template>
          </v-checkbox>
        </v-card-text>
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-toolbar dense flat color="white">
          <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
            물품정보
          </v-card-subtitle>
          <v-spacer></v-spacer>
          <v-btn @click="AddRow(editedItem.cLabel)" class="font-weight-bold" small dark width="70px"><v-icon small class="mr-1">mdi-plus</v-icon><div class="text-caption">추가</div></v-btn>
        </v-toolbar>
        <v-card-text>
          <div>※ SK 스페셜티 표준OS가 아닌 경우 EP센터 점검 후 사용이 가능하며, 허위로 OS를 선택하여 신청한 경우 허위 정보 제출로 산업 보안 규정에 의거하여 위규 처리 될 수 있습니다. </div>
        </v-card-text>        
        <v-card-text class="pt-0 pb-0">
          <v-data-table
            :items="zCorCarryItem"
            :headers="headers2"
            :hide-default-footer="true">
            <template v-slot:header.cCarmeraNm="{ }">
              <div>제조사/모델<strong class="ml-1 red--text">*</strong></div>
            </template>
            <template v-slot:header.cCapacity="{ }">
              <div>용량<strong class="ml-1 red--text">*</strong></div>
            </template>
            <template v-slot:header.cSerialNum="{ }">
              <div>Serial No.<strong class="ml-1 red--text">*</strong></div>
            </template>
            <template v-slot:header.cStickerZone="{ }">
              <div>스티커 배부 장소<strong class="ml-1 red--text">*</strong></div>
            </template>
            <template v-slot:header.cFileId="{ }">
              <div>Serial No. 사진첨부<strong class="ml-1 red--text">*</strong></div>
            </template>
            <template v-slot:item.cCarmeraNm="{ item }">
              <v-text-field v-model="item.cCarmeraNm" persistent-placeholder></v-text-field>
            </template>
            <template v-slot:item.cCapacity="{ item }">
              <v-text-field v-model="item.cCapacity" persistent-placeholder></v-text-field>
            </template>
            <template v-slot:item.cSerialNum="{ item }">
              <v-text-field v-model="item.cSerialNum" persistent-placeholder></v-text-field>
            </template>
            <template v-slot:item.cStickerZone="{  }">
              <v-text-field value="통합보안실" disabled persistent-placeholder></v-text-field>
            </template>
            <template v-slot:item.cFileId="{ index,item }">
              <v-file-input
                v-on:change="onSelFile(item.NowSelFile,index)"
                v-model="item.NowSelFile"
                style="width:200px"
                accept="image/png"
                placeholder="파일선택"
                class="essetial_input"
              ></v-file-input>
            </template>
            <template v-slot:item.cDel="{ item }">
              <v-icon @click="DelRow(item)" color="black">mdi-close</v-icon>
            </template>
            <template v-slot:no-data>
              <div class="black--text">물품정보를 입력하여 주세요.</div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>


      <!-- 반입물품 분류 지입자재 선택 시 -->
      <v-card flat tile v-if="editedItem.cLabel == '3'">
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-toolbar dense flat color="white">
          <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
            지입자재 안내 및 동의서
          </v-card-subtitle>
        </v-toolbar>
        <v-card-text>
          <div>
            업체물품 반입신청 품목에 대해서는 업체물품 소 유의 물품으로 작업 공구/가자재/Warranty 기간 내 무상교환품만 해당되며, 
            Warranty 기간 내 발생한 교체 건은 비용발생 없이 무상교체를 진행함을 동의합니다. (SK 스페셜티에 비용을 청구하지 않는 물품)
            ※ 업체물품은 협력사 또는 제 3자 소유물품으로 SK 스페셜티가 구매대금을 지급하지 않습니다.
          </div>
          <v-checkbox v-model="bPolicyCheck4" dense class="mt-2" color="black">
            <template v-slot:label>
              <div class="black--text">동의합니다.</div>
            </template>
          </v-checkbox>
        </v-card-text>
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-toolbar dense flat color="white">
          <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
            물품정보
          </v-card-subtitle>
          <v-spacer></v-spacer>
          <v-btn @click="AddRow(editedItem.cLabel)" class="font-weight-bold" small dark width="70px"><v-icon small class="mr-1">mdi-plus</v-icon><div class="text-caption">추가</div></v-btn>
        </v-toolbar>
        <v-card-text>
          <div>
            ※ 전산기기(노트북, 데스크톱)는 반입물품 분류를 전산기기로 선택 후 신청 바랍니다.
            물품 입력 시 정확하게 기입하시기 바랍니다. 예) 스마트폰(X) -> 갤럭시S21(O), 펌프(X) -> 모노펌프 회색 1M(O)
          </div>
        </v-card-text>
        <v-card-text class="pt-0 pb-0">
          <v-data-table
            :items="zCorCarryItem"
            :headers="headers3"
            :hide-default-footer="true">
            <template v-slot:header.cPaperMatNm="{ }">
              <div>품명<strong class="ml-1 red--text">*</strong></div>
            </template>
            <template v-slot:header.cSerialNum="{ }">
              <div>Serial No.<strong class="ml-1 red--text">*</strong></div>
            </template>
            <template v-slot:header.cQuantity="{ }">
              <div>반입수량<strong class="ml-1 red--text">*</strong></div>
            </template>
            <template v-slot:header.cUnit="{ }">
              <div>단위<strong class="ml-1 red--text">*</strong></div>
            </template>

            <template v-slot:item.cPaperMatNm="{ item }">
              <v-text-field v-model="item.cPaperMatNm" persistent-placeholder></v-text-field>
            </template>
            <template v-slot:item.cSerialNum="{ item }">
              <v-text-field v-model="item.cSerialNum" persistent-placeholder></v-text-field>
            </template>
            <template v-slot:item.cQuantity="{ item }">
              <v-text-field v-model="item.cQuantity" type="number" persistent-placeholder hint="숫자만 입력하세요."></v-text-field>
            </template>
            <template v-slot:item.cUnit="{ item }">
              <div style="max-width:170px;">
                <v-select
                  v-model="item.cUnit"
                  :items="zCarryUnit"
                  v-if="item.cUnit != '13'"
                ></v-select>
                <v-text-field
                  v-model="item.cUnitDirect"
                  v-if="item.cUnit == '13'"
                  @click:append="item.cUnit = '1';item.cUnitDirect = ''"
                  append-icon="refresh"
                  persistent-placeholder
                ></v-text-field>
              </div>
              <!-- <v-text-field v-model="item.cUnit" persistent-placeholder></v-text-field> -->
            </template>
            <template v-slot:item.cDel="{ item }">
              <v-icon @click="DelRow(item)" color="black">mdi-close</v-icon>
            </template>
            <template v-slot:no-data>
              <div class="black--text">물품정보를 입력하여 주세요.</div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>


      <v-card-text align="center">
        <v-divider class="ma-4 mr-0 ml-0"></v-divider>
        <v-btn @click="$router.push({name: 'MainBoard'});" text class="mr-2"><v-icon class="mr-2">dashboard</v-icon>홈</v-btn>
        <v-btn @click="SetCorCarryLog('')" width="100px" dark class="ml-2">
          <v-icon class="ml-2">post_add</v-icon>신청
        </v-btn>
      </v-card-text>
    </v-card> 
    <MapDialog ref="MapDialogRef" @SetMap="SetMap"/>
  </div>
</template>

<script>
import BasicInfo from "../BasicInfo.js";
import axios from "axios";
import EventBus from "@/eventBus.js";
import { mapState } from "vuex";

import IronDate from '@/components/iron28Calendar/src/IronDate4.vue';
import Util from "../Util.js";

import MapDialog from "../components/MapDialog.vue";

export default {
  components: {
    MapDialog,
    IronDate
  },
  data: () => ({
    loading : false,
    bPolicyCheck1 : false,
    bPolicyCheck2 : false,
    bPolicyCheck3 : false,
    bPolicyCheck4 : false,
    zMapZoneInfo : [],
    zCorCarryItem : [],
    headers1 : [
      { text: '제조사/모델 *', value: 'cComEquipNm', align: '',sortable : false},
      { text: 'OS *', value: 'cOsNm',sortable : false},
      { text: 'Serial No. *', value: 'cSerialNum',sortable : false},
      { text: 'Mac Address', value: 'cMaxAddr',sortable : false},
      { text: '삭제', value: 'cDel',sortable : false},
    ],
    headers2 : [
      { text: '제조사/모델 *', value: 'cCarmeraNm', align: '',sortable : false},
      { text: '용량 *', value: 'cCapacity',sortable : false},
      { text: 'Serial No. *', value: 'cSerialNum',sortable : false},
      { text: '스티커 배부 장소 *', value: 'cStickerZone',sortable : false},
      { text: 'Serial No. 사진첨부 *', value: 'cFileId',sortable : false},
      { text: '삭제', value: 'cDel',sortable : false},
    ],
    headers3 : [
      { text: '품명 *', value: 'cPaperMatNm', align: '',sortable : false},
      { text: 'Serial No. *', value: 'cSerialNum',sortable : false},
      { text: '반입수량 *', value: 'cQuantity',sortable : false},
      { text: '단위 *', value: 'cUnit',sortable : false},
      { text: '삭제', value: 'cDel',sortable : false},
    ],
    zChargeInfo : {
      cUserId: "",
      cUserNm :  "",
      cPartNm :  "",
      cEmailAddr1 :  "",
      cEmailAddr2 :  "",
    },
    editedItem: {
      cBizCode: "",
      cLocal : "",
      cCorpNmKor: "",
      cCorpNmEng : "",
      cLabel : "1",
      cDirLabel : "",
      cZone : "",
      cReason : "",
      cSort : "1",
      cLongReason : "",
      sStartDate : Util.sFormatDate(Date()),
      sEndDate : Util.sFormatDate(Util.sTomorrowSel()),
      sNowSelectDate :  Util.sFormatDate(Date()) + " ~ " +  Util.sFormatDate(Util.sTomorrowSel()),
    },
    defaultItem: {
      cBizCode: "",
      cLocal : "",
      cCorpNmKor: "",
      cCorpNmEng : "",
      cLabel : "1",
      cDirLabel : "",
      cZone : "",
      cReason : "",
      cSort : "1",
      cLongReason : "",
      sStartDate : Util.sFormatDate(Date()),
      sEndDate : Util.sFormatDate(Util.sTomorrowSel()),
      sNowSelectDate :  Util.sFormatDate(Date()) + " ~ " +  Util.sFormatDate(Util.sTomorrowSel()),
    },
    zDefaultChargeInfo : {
      cUserId: "",
      cUserNm :  "",
      cLevNm : "",
      cPartNm : "",
      cEmail : "",
    },
  }),

  computed: {
    ...mapState(["CustomInfo","zCarryItem","zCarryUnit","zEmaillAddr","zFileType","FMaxSize3"]),
  },

  created() {
  },
  mounted() {
    this.GetCorpInfo();
    this.init();
  },

  methods : {
    init() {
      this.editedItem.cLongReason  = ""
      this.editedItem.cLabel  = "1"
      this.editedItem.cDirLabel  = ""
      this.editedItem.cZone  = ""
      this.editedItem.cReason = "";
      this.editedItem.cSort = "1";
      this.editedItem.cLongReason = "";
      this.editedItem.sStartDate = Util.sFormatDate(Date());
      this.editedItem.sEndDate = Util.sFormatDate(Util.sTomorrowSel());
      this.editedItem.sNowSelectDate =  Util.sFormatDate(Date()) + " ~ " +  Util.sFormatDate(Util.sTomorrowSel());

      this.zMapZoneInfo = [];
      this.zCorCarryItem = [];
      this.AddRow(this.editedItem.cLabel)

      this.zChargeInfo.cUserId = ""
      this.zChargeInfo.cPartNm = ""
      this.zChargeInfo.cUserNm = ""
      this.zChargeInfo.cEmailAddr1 = ""
      this.zChargeInfo.cEmailAddr2 = this.zEmaillAddr[0]
    },

    // 맵선택 다이올로그창 열기
    ShowMapDialog(){
      this.$refs.MapDialogRef.ShowDialog(this.zMapZoneInfo)
    },
    
    ResetEmailInfo(){
      this.zChargeInfo.cUserId = ""
      this.zChargeInfo.cUserNm = ""
    },

    GetChargeInfo(){
      var posData = {
        CustomId : this.CustomInfo.CustomId,
        Email : this.zChargeInfo.cEmailAddr1 + "@" +this.zChargeInfo.cEmailAddr2,
      };
      axios
        .post(BasicInfo.UIL_API + "GetChargeInfo", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            if (res.data.Result.length == 0) {
              EventBus.$emit("onShowMsgBox","입력하신 이메일을 다시 확인하여 주세요.","입력하신 이메일과 일치하는 담당자가 없습니다.");
            } else {
              this.zChargeInfo.cUserId = res.data.Result[0].cUserId
              this.zChargeInfo.cUserNm = res.data.Result[0].cUserNm
              this.zChargeInfo.cPartNm = res.data.Result[0].cPartNm
            }
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    // 맵선택 후 정보 가져오기
    SetMap(zZone,zZoneNm){
      this.zMapZoneInfo = zZone
      this.editedItem.cZone = zZoneNm
    },

    // 업체정보 가져오기
    GetCorpInfo(){
      var posData = {
        CorpId : this.CustomInfo.CorpId,
        CustomId : this.CustomInfo.CustomId,
      };
      axios
        .post(BasicInfo.UIL_API + "GetCorpInfo", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            if (res.data.Result.length != 0) {
              this.editedItem.cBizCode = res.data.Result[0].cBizCode
              this.editedItem.cCorpNmKor = res.data.Result[0].cCorpNmKor
              this.editedItem.cCorpNmEng = res.data.Result[0].cCorpNmEng
              this.editedItem.cLocal = res.data.Result[0].cLocal
            } else {
              this.editedItem.cBizCode = "NONE"
              this.editedItem.cCorpNmKor = "NONE"
            }
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
        });
    },

    overmaxperiod(value){
      EventBus.$emit("onShowMsgBox", value.sTitle,value.sMsg);
    },

    // 날짜 변경하기
    onDateRangeChange(daterange){
      this.editedItem.sStartDate = Util.sFormatDate(daterange.startDate);
      this.editedItem.sEndDate = Util.sFormatDate(daterange.endDate);
      // this.editedItem.sNowSelectDate = this.editedItem.sStartDate + " ~ " +  this.editedItem.sEndDate;
      this.editedItem.cSort == "2"?this.editedItem.sNowSelectDate = this.editedItem.sStartDate:this.editedItem.sNowSelectDate = this.editedItem.sStartDate + " ~ " +  this.editedItem.sEndDate
    },

    // 미반출 시 날짜 표기를 하루로 변경하기
    DisableSelect() {
      if (this.editedItem.cSort == "2") {
        this.editedItem.sEndDate = this.editedItem.sStartDate;
        this.editedItem.sNowSelectDate = this.editedItem.sStartDate
      } else {
        this.editedItem.sStartDate = Util.sFormatDate(Date());
        this.editedItem.sEndDate = Util.sFormatDate(Util.sTomorrowSel());
        this.editedItem.sNowSelectDate = this.editedItem.sStartDate + " ~ " +  this.editedItem.sEndDate;
      }
    },

    // 테이블 입력 칸 추가하기
    AddRow(value){
      if (this.zCorCarryItem.length >= 99) {
        EventBus.$emit("onShowMsgBox", "입력 가능한 최대 건수를 넘었습니다.","물품목록에 대한 정보는 최대 99건 까지 입력 가능합니다.");
        return
      }

      if (value == "1"){
        this.zCorCarryItem.push({cComEquipNm : "", cOsNm : "", cSerialNum : "", cMaxAddr : ""})
      } else if (value == "2") {
        this.zCorCarryItem.push({cCarmeraNm : "", cCapacity : "", cSerialNum : "", cStickerZone : "", cFileId : "",NowSelFile : null})
      } else {
        this.zCorCarryItem.push({cPaperMatNm : "", cSerialNum : "", cQuantity : "", cUnit : "1",cUnitDirect :""})
      }
    },

    // 테이블 입력 칸 삭제하기
    DelRow(row) {
      let iDelIndex = this.zCorCarryItem.indexOf(row);
      if (iDelIndex != -1) {  
        this.zCorCarryItem.splice(iDelIndex, 1);
      }
    },

    // 파일 선택시 파일 경로 및 데이터 가져오기
    onSelFile(NowSelFile,index) {
      let bFileType = false
      if (NowSelFile != null)  {
        if (NowSelFile.size > this.FMaxSize3)  {
          setTimeout(() => {
            this.zCorCarryItemInfo[index].NowSelFile = null;
          }, 300);
          EventBus.$emit("onShowMsgBox","첨부하신 파일의 용량의 크기를 확인하여 주세요.","첨부하실수 있는 파일의 크기는 최대 10MB까지 입니다.");
          return
        }

        for ( let i in this.zFileType) {
          if (this.zFileType[i] == NowSelFile.type) {
            bFileType =  true;
            break
          }
        }
      } else {
        bFileType = true
      }

      if (!bFileType) {
        setTimeout(() => {
          this.zCorCarryItem[index].NowSelFile = null;  
        }, 300);

        EventBus.$emit("onShowMsgBox","첨부하신 파일의 형식을 확인하여 주세요.","첨부하실수 있는 파일의 형식은 JPG,JPEG,PNG,GIF 입니다.");
        return
      }

      const reader = new FileReader
      try {
        reader.readAsDataURL(NowSelFile)        
      }
      catch (error) {
        EventBus.$emit("onFileBus", true,""+error);
        // EventBus.$emit("onShowMsg", true,""+error);
      }
    },

    // 파일 저장후 생성된 이름 가져오는 함수
    bSendSvrFile(NowSelFile){
      var d = new Date();
      var Year = d.getFullYear(); 
      var fileName = NowSelFile.name;
      var Extend = Util.getExtension(fileName).toUpperCase();
      var sFileTypeId = Util.sGetId(Util.sGetFileType(NowSelFile.type));
        
      let formData = new FormData();
      formData.append('uploadfile', NowSelFile);
      return new Promise((resolve) => (
        axios.post(BasicInfo.UIL_API + "UploadFile?PublicFile=Y&Year="+Year+"&FileNm="+fileName+"&Extend="+Extend+"&MimeType="+NowSelFile.type+"&Size="+NowSelFile.size+"&FileTypeId="+sFileTypeId,
                formData,
                {
                headers: {
                  // "Authorization": this.CustomInfo.Token,
                  'Content-Type': 'multipart/form-data',
                }
              }
            )
            .then(res => {
              resolve(res);
            })
            .catch(err =>{
              resolve(null);
              EventBus.$emit("onShowMsg",true, "File Send Error-Network Error!" + err)
          })
      ));
    },

    // 업체물품 반입 신청하기
    async SetCorCarryLog(){
      if (this.zChargeInfo.cUserId == "") {
        EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "담당자를 선택하여 주세요.");
        return
      }

      if (this.editedItem.cLabel == "") {
        EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "반입물품 분류를 선택하여 주세요.");
        return
      }

      if (this.editedItem.cZone == "") {
        EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "반입건물을 선택하여 주세요.");
        return
      }

      if (this.editedItem.cReason == "" || this.editedItem.cLongReason == "") {
        EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "반입사유 및 상세설명을 입력하여 주세요.");
        return
      }

      if (this.editedItem.cLabel == "1" && this.bPolicyCheck1 == false) {
        EventBus.$emit("onShowMsgBox","최신 OS 및 백신설치의무에 대한 동의가 필요합니다.", "최신 OS 및 백신설치의무 안내 및 동의를 읽으신 후 동의하기를 선택하여 주세요.");
        return
      }

      if (this.editedItem.cLabel == "1" && this.bPolicyCheck2 == false) {
        EventBus.$emit("onShowMsgBox","추가 보안 서약에 대한 동의가 필요합니다.", "추가 보안 서약를 읽으신 후 동의하기를 선택하여 주세요.");
        return
      }

      if (this.editedItem.cLabel == "2" && this.bPolicyCheck3 == false) {
        EventBus.$emit("onShowMsgBox","추가 보안 서약에 대한 동의가 필요합니다.", "추가 보안 서약를 읽으신 후 동의하기를 선택하여 주세요.");
        return
      }

      if (this.editedItem.cLabel == "3" && this.bPolicyCheck4 == false) {
        EventBus.$emit("onShowMsgBox","지입자재 안내 동의에 대한 동의가 필요합니다.", "지입자재 안내 동의서를 읽으신 후 동의하기를 선택하여 주세요.");
        return
      }

      if (this.editedItem.cLabel == "1" && this.zCorCarryItem.length == 0) {
        EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "전산기기 물품을 등록하여 주세요.");
        return
      }

      if (this.zCorCarryItem.length == 0) {
        if (this.editedItem.cLabel == "1") {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "전산기기 물품을 등록하여 주세요.");
          return
        } else if (this.editedItem.cLabel == "2") {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "디지털카메라 물품을 등록하여 주세요.");
          return
        } else {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "디지털카메라 물품을 등록하여 주세요.");
          return
        }
      }

      let j = 0;
      for (j in this.zCorCarryItem) {
        if (this.zCorCarryItem[j].cSerialNum == "") {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "Serial No. 항목을 입력하여 주세요.");
          return
        }
        if (this.editedItem.cLabel == "1" && this.zCorCarryItem[j].cComEquipNm == "") {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "제조사/모델 항목을 입력하여 주세요.");
          return
        }
        if (this.editedItem.cLabel == "1" && this.zCorCarryItem[j].cOsNm == "") {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "OS 항목을 입력하여 주세요.");
          return
        }
        // if (this.editedItem.cLabel == "1" && this.zCorCarryItem[j].cSerialNum == "") {
        //   EventBus.$emit("onShowMsg",true,  "Serial No. 항목을 입력하여 주세요.");
        //   return
        // }
        // if (this.editedItem.cLabel == "1" && this.zCorCarryItem[j].cMaxAddr == "") {
        //   EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "Mac Address 항목을 입력하여 주세요.");
        //   return
        // }
        if (this.editedItem.cLabel == "2" && this.zCorCarryItem[j].cCarmeraNm == "") {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "제조사/모델 항목을 입력하여 주세요.");
          return
        }
        if (this.editedItem.cLabel == "2" && this.zCorCarryItem[j].cCapacity == "") {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "용량 항목을 입력하여 주세요.");
          return
        }
        // if (this.editedItem.cLabel == "2" && this.zCorCarryItem[j].cSerialNum == "") {
        //   EventBus.$emit("onShowMsg",true,  "Serial No. 항목을 입력하여 주세요.");
        //   return
        // }

        if (this.editedItem.cLabel == "2" && this.zCorCarryItem[j].NowSelFile == null) {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "파일을 첨부하여 주세요.");
          return
        }
        if (this.editedItem.cLabel == "3" && this.zCorCarryItem[j].cPaperMatNm == "") {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "품명을 입력하여 주세요.");
          return
        }
        // if (this.editedItem.cLabel == "3" && this.zCorCarryItem[j].cSerialNum == "") {
        //   EventBus.$emit("onShowMsg",true,  "Serial No. 항목을 입력하여 주세요.");
        //   return
        // }
        if (this.editedItem.cLabel == "3" && this.zCorCarryItem[j].cQuantity == "") {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "반입수량을 입력하여 주세요.");
          return
        }
        if (this.editedItem.cLabel == "3" && this.zCorCarryItem[j].cUnit == "") {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "단위를 선택하여 주세요.");
          return
        }
        if (this.editedItem.cLabel == "3" && this.zCorCarryItem[j].cUnit == "13" && this.zCorCarryItem[j].cUnitDirect == "") {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "단위를 입력하여 주세요.");
          return
        }
        if (this.editedItem.cLabel == "3" && this.zCorCarryItem[j].cUnitDirect.length > 20) {
          EventBus.$emit("onShowMsgBox","단위를 직접 입력 하실 때 20자 넘게 입력하셨습니다.",  "띄어쓰기를 포함하여 최대 20자까지 입력이 가능합니다.");
          return
        }
      }

      this.loading = true;
      if (this.editedItem.cLabel == "2") {
        let i = 0
        for (i in this.zCorCarryItem) {
          if (this.zCorCarryItem[i].NowSelFile != null) {
            var res = await this.bSendSvrFile(this.zCorCarryItem[i].NowSelFile);
            if (res.data.ResultCd == "00") {
              this.zCorCarryItem[i].cFileId = res.data.FileId;
            } else {
              EventBus.$emit("onShowMsg",true, "File Send Error-Network Error!");
              return;
            }
          }
        }
      }

      if (this.editedItem.cLabel == "3") {
        let i = 0
        for (i in this.zCorCarryItem) {
          if (this.zCorCarryItem[i].cUnit == "13") {
            this.zCorCarryItem[i].cUnit = this.zCorCarryItem[i].cUnitDirect
          }
        }

        for (i in this.zCorCarryItem) {
          if (this.zCorCarryItem[i].cUnit == "13") {
            this.zCorCarryItem[i].cUnit = this.zCorCarryItem[i].cUnitDirect
          }
        }
      }

      this.loading = false;

      var posData = {
        ReqId : "",
        CustomId : this.CustomInfo.CustomId,
        CustomNm : this.CustomInfo.CustomNm,
        CorpNm : Util.ChangeCorpNm3Data(this.CustomInfo.Local,this.CustomInfo.CorpNmKor,this.CustomInfo.CorpNmEng),
        CorpId : this.CustomInfo.CorpId,
        // ChargeEmail : this.zChargeInfo.cEmailAddr1 + "@" +this.zChargeInfo.cEmailAddr2,
        ChargeEmail : Util.AddEmail1and2(this.zChargeInfo.cEmailAddr1,this.zChargeInfo.cEmailAddr2),
        ChargeUserId : this.zChargeInfo.cUserId,
        ChargeUserPartNm : this.zChargeInfo.cPartNm,
        Label : this.editedItem.cLabel,
        Zone : this.editedItem.cZone,
        Reason : this.editedItem.cReason,
        LongReason : this.editedItem.cLongReason,
        Sort : this.editedItem.cSort,
        CarryInDate : this.editedItem.sStartDate,
        CarryOutDate : this.editedItem.sEndDate,
        MapTreeInfo : Util.ChangeArray(this.zMapZoneInfo),
        CorCarryItem : this.zCorCarryItem,
      };

      axios
        .post(BasicInfo.UIL_API + "SetCorCarryLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {

            this.init();
            EventBus.$emit("onShowMsg",false,  "신청이 완료되었습니다.");
          } else if (res.data.ResultCd == "55") {
            EventBus.$emit("onShowMsgBox","출입 정지 기간 중입니다.", res.data.Msg);
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
        });
    }
  }
}
</script>